__turbopack_context__.v({
  "alwaysShrink": "Jp4h2q_alwaysShrink",
  "container": "Jp4h2q_container",
  "hasGeneralBanner": "Jp4h2q_hasGeneralBanner",
  "headerHidden": "Jp4h2q_headerHidden",
  "headerStack": "Jp4h2q_headerStack",
  "navbarShrinked": "Jp4h2q_navbarShrinked",
  "navbarWrapper": "Jp4h2q_navbarWrapper",
  "spacer": "Jp4h2q_spacer",
  "wrapper": "Jp4h2q_wrapper",
});
